// extracted by mini-css-extract-plugin
export default {"container":"DocumentPage_container__hwLCg","section":"DocumentPage_section__55pS3"};